import React, { useState } from 'react';
import PropTypes from 'prop-types';

import KnoxGuardModal from './KnoxGuardModal/KnoxGuardModal';

import content from 'assets/content/product.content.json';

import Knox from 'assets/images/general/knox.png';
import KnoxBlack from 'assets/images/general/knox-security-black.png';
import { ReactComponent as Info } from 'assets/images/general/info.svg';

import './KnoxSecurity.scss';

function KnoxSecurity({ isBlack }) {
    const [isModalOpen, setModalOpen] = useState(false);
    const sectionStyle = `section ${isBlack ? 'section__black' : ''}`;
    const headingStyle = `section__heading ${isBlack ? 'section__heading__black' : ''}`;
    const textStyle = `section__text ${isBlack ? 'section__text__black' : ''}`;
    const imageSource = isBlack ? KnoxBlack : Knox;
    const iconStyle = `icon ${isBlack ? 'info-black' : ''}`;

    const handleToggle = () => setModalOpen(!isModalOpen);

    return (
        <>
            <div className={sectionStyle} onClick={handleToggle}>
                <img src={imageSource} className='max-h-100' alt='knox' />
                <div className='w-100'>
                    <div className={headingStyle}>
                        <p className='section__heading__knox'>{content?.CONTENT.SECURED_BY}</p>
                        <p className='section__heading__learn'>
                            <Info className={iconStyle} alt='info' />
                        </p>
                    </div>
                    <p className={textStyle}>{content?.CONTENT.SECURED_BY_DESC}</p>
                </div>
            </div>
            <KnoxGuardModal isOpen={isModalOpen} onToggle={handleToggle}/>
        </>
    );
}

KnoxSecurity.propTypes = {
    isBlack: PropTypes.bool
};

export default KnoxSecurity;
